import { FC, useState, useContext } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
  Menu,
  MenuItem,
  CircularProgress,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import { BuyGainsModalProps } from "../../interfaces";
import graphQLClient from "../../utils/authHeader";
import ADD_NON_EVM_WALLET_MUTATION from "../../utils/mutations/wallet/addNonEvmWalletMutation"
import AlertContext from "../../store/Alert/AlertContext";

const nonEvmNetworks = [
  {label:"Bitcoin", value:"BITCOIN"},
  {label:"Partisia", value:"PARTISIA"},
  {label:"Solana", value:"SOLANA"},
  {label:"Sui", value:"SUI"},
]

const AddWalletDoalog: FC<BuyGainsModalProps> = ({ open, setOpen }) => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const { setAlert } = useContext<any>(AlertContext);
  const [network, setNetwork] = useState("")
  const [networkAnchor, setNetworkAnchor] = useState(null)
  const [loading, setLoading] = useState(false)
  const [address, setAddress] = useState("")
  const classes = useStyles();
  

  const handleClose = () => {
    setOpen(false);
    setNetworkAnchor(null)
    setNetwork("")
    setAddress("")
  };

  const handleNetworkClick = (value:string) => {
    setNetwork(value)
    setNetworkAnchor(null)
  }

  const openNetwork = (e:any) => {
    e.preventDefault()
    setNetworkAnchor(e.currentTarget)
  }

  const handleAddressInput = (e:any) => {
    setAddress(e.target.value)
  }

   

  const handleSubmit = () => {
  
    setLoading(true)

   const variables = { 
      address:address,
      blockchain:network
    }
    graphQLClient
     .request(ADD_NON_EVM_WALLET_MUTATION, variables)
     .then(() => {
      setAlert("Wallet Added Successfully", "success")
        setLoading(false)
        setOpen(false)
        setAddress("")
        setNetwork("")
      })
      .catch((error:any) => {
        setAlert("Oops! Looks like something wrong happen", "error")
        setLoading(false)
        
      }
    );
  }

  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={` ${classes.modalpages} ${classes.buymodal}`}
        >
          <Box
            ml={isActive ? "1.2rem" : "2rem"}
            my={isActive ? "1.2rem" : "2rem"}
            mr={isActive ? "1.2rem" : "2rem"}
            
          >
            <Box className="relative-box">
              {(
                <img
                  src={cross}
                  alt=""
                  className="cross-icon"
                  style={{
                    top:"0",
                    right:"0",
                  }}
                  onClick={handleClose}
                />
              )}
              
              <Typography
                variant="h4"
                color="primary"
                >
                  Add Non-EVM Wallet
                  </Typography>

               <Box 
               border={"1px solid rgba(0, 0, 0, 0.25)"}
               borderRadius=".75rem"
               display="flex"
               justifyContent="space-between"
               width={"90%"}
               alignItems="center"
               padding=".5rem"
               style={{cursor:"pointer"}}
               onClick={openNetwork}
               height="1.5rem"
               margin="1.5rem 0 1rem 0">
               <Typography
               variant="body1"
                color="secondary"
               >
                {network || "Select Network"}
               </Typography>
               <svg 
               fill="#000000" 
               height=".7rem" 
               width=".7rem" 
               version="1.1" 
               id="Layer_1" 
               xmlns="http://www.w3.org/2000/svg" 
               xmlnsXlink="http://www.w3.org/1999/xlink" 
               viewBox="0 0 330 330" 
               xmlSpace="preserve">
                <g id="SVGRepo_bgCarrier" stroke-width="0">
                  </g>
                  <g 
                  id="SVGRepo_tracerCarrier" 
                  stroke-linecap="round" 
                  stroke-linejoin="round">
                    </g>
                    <g 
                    id="SVGRepo_iconCarrier">
                      <path 
                      id="XMLID_225_" 
                      d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z">
                        </path> 
               </g>
               </svg>
               </Box>
                <Menu
                  id="basic-menu"
                  style={{marginBottom:"-3rem"}}
                  anchorEl={networkAnchor}
                  open={Boolean(networkAnchor)}
                  onClose={(e:any)=>{
                    setNetworkAnchor(null)}}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                  >
                  {nonEvmNetworks.map((network, index)=>(
                    <MenuItem key={index} onClick={()=>handleNetworkClick(network.value) }>{network.label}</MenuItem>
                  ))}
    
                  </Menu>

                  <Box marginBottom={"1.5rem"}>
                    <input 
                    placeholder="Paste the address*" 
                    type={"text"} 
                    onChange={handleAddressInput}
                    value={address}
                    style={{
                     border:"1px solid rgba(0, 0, 0, 0.25)",
                     borderRadius:".75rem",
                     padding:".65rem .5rem",
                     width:"90%",
                     height:"1.5rem",
                     fontSize:address ? '.8rem' : "1rem" ,
                     outline:"none",
                     color:"#11302D",
                    }}/>
                  </Box>
                  <Box width="94%" display={"flex"} justifyContent="flex-end" marginTop="1rem"> 
                  <Button
                   variant="contained"
                   color="secondary"
                   onClick={handleSubmit}
                   style={{width:"8rem", height:"2.5rem"}}
                  
                  >
                    {loading ? <CircularProgress size={"1.5rem"}/> : 'Add Wallet'}
                  </Button>
                  </Box>
              
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default AddWalletDoalog
